import { useMemo } from "react";
import { useSelector } from "react-redux";

const usePermission = (permission) => {
  const userData  = useSelector((state) => state.loginSlice);
 
  return useMemo(
    () => userData?.permissions?.includes(permission),
    [permission, userData]
  );
};

export default usePermission;